/**
 * Tabs component functionality.
 *
 * @module Tabs
 * @author EN GARDE
 * @version 1
 */

var EN = EN || {};

EN.Tabs = (function (_, $) {
	'use strict';

	var options = {
		scrollSpeed: 250,
		selectors: {
			component: '.en-tabs',
			scroller: '.en-tabs__inner',
			tabs: '.en-tabs__tabs',
			tabInner: '.en-tab__inner',
			navigation: '.en-tabs__navigation',
			navigationPrev: '.en-tabs__navigation--prev',
			navigationNext: '.en-tabs__navigation--next'
		},
		classNames: {
			hasNavigation: 'en-tabs--has-navigation'
		}
	};

	/**
	 * Shows or hides the navigation if the tabs are too wide to fit in the container.
	 * @memberof module:Tabs
	 * @param {jQuery} $component
	 * @return {jQuery}
	 */
	var showHideNavigation = function ($component) {
		var $scroller = $component.find(options.selectors.scroller);
		var $tabs = $component.find(options.selectors.tabs);
		var $navigation = $component.find(options.selectors.navigation);

		if ($scroller.width() !== $tabs.width()) {
			$component.addClass(options.classNames.hasNavigation);
		}
		else {
			$component.removeClass(options.classNames.hasNavigation);
		}
	};

	/**
	 * Initializes the scroll behavior.
	 * @memberof module:Tabs
	 */
	var init = function (settings) {
		options = $.extend({}, options, settings);

		$(options.selectors.component).each(function () {
			showHideNavigation($(this));
		});

		$(window).on('resize', _.debounce(function () {
			$(options.selectors.component).each(function () {
				showHideNavigation($(this));
			});
		}, 200));

		// scroll behavior
		$(document).on('click', options.selectors.navigation, function () {
			var $this = $(this);
			var $component = $this.closest(options.selectors.component);
			var $scroller = $component.find(options.selectors.scroller);
			var $tabs = $component.find(options.selectors.tabs);

			var direction = $this.hasClass(options.selectors.navigationNext.substr(1)) ? 'next' : 'prev';
			var maxScrollValue = $tabs.width() - $scroller.width();
			var scrollValue = direction === 'next' ? $scroller.scrollLeft() + $scroller.width() : $scroller.scrollLeft() - $scroller.width();

			if (scrollValue < 0) {
				scrollValue = 0;
			}
			else if (scrollValue > maxScrollValue) {
				scrollValue = maxScrollValue;
			}

			$scroller.stop().animate({
				scrollLeft: scrollValue
			}, options.scrollSpeed);
		});
	};

	// exports
	return {
		init: init,
		showHideNavigation: showHideNavigation
	};
}(lodash, jQuery));
